import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading } from '@angular/router'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { API_BASE_URL, headersInterceptor } from 'superlikers-microsites-api'
import { SPANISH_ERROR_MESSAGES, VALIDATION_ERROR_MESSAGES } from 'superlikers-dynamic-forms'
import { CustomPreloadingStrategy } from '@core/custom-preloading-strategy'

import { routes } from './app.routes'
import { environment } from '../environments/environment'

import { registerLocaleData } from '@angular/common'
import localeEsMx from '@angular/common/locales/es-MX'

registerLocaleData(localeEsMx)

import { register } from 'swiper/element/bundle'
register()

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withPreloading(CustomPreloadingStrategy), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([headersInterceptor])),
    {
      provide: API_BASE_URL,
      useValue: environment.baseUrl
    },
    {
      provide: VALIDATION_ERROR_MESSAGES,
      useFactory: () => SPANISH_ERROR_MESSAGES
    },
    { provide: LOCALE_ID, useValue: 'es-MX' }
  ]
}
